import MoveWizard from './move-wizard';
export default MoveWizard;
